/**
 * Quality of life for transition handling.
 * Adds / removes transitionend events. Resolves on complete
 */
export const transitionDone = (
  el: HTMLElement
): Promise<'shown' | 'hidden'> => {
  return new Promise((resolve) => {
    const callback = () => {
      el.removeEventListener('transitionend', callback);
      resolve;
    };
    el.addEventListener('transitionend', callback);
    // ??
  });
};

/**
 * handles hiding and showing elements properly (with display),
 * along with transitions, so they are no longer viewable in the dom.
 * - OnHide remove show class, listen for transition end, then display: none on finish
 * - OnShow, display block on start then add a show class
 * @param el
 * @param className
 * @param show
 * @returns a promise of resolving as either 'show' or 'hidden'
 */
export const displayTransition = (
  el: HTMLElement,
  className: string,
  show: boolean = true
): Promise<'shown' | 'hidden'> => {
  return new Promise((resolve) => {
    if (show) {
      el.addEventListener(
        'transitionend',
        (e: Event) => {
          if (
            e.target === el ||
            e.composedPath().some((el) => el === e.target)
          ) {
            resolve('shown');
          }
        },
        { once: true }
      );
      el.style.display = 'block';
      el.dataset.displayTransition = 'true';
      setTimeout(() => el.classList.add(className), 20);
    } else {
      el.addEventListener(
        'transitionend',
        (e: Event) => {
          if (
            e.target === el ||
            e.composedPath().some((el) => el === e.target)
          ) {
            el.style.display = 'none';
            resolve('hidden');
          }
        },
        { once: true }
      );
      el.classList.remove(className);
    }
  });
};
